module.exports = __webpack_public_path__ + "static/media/sweet_view_8.b662476b.jpg";